import { Services } from '../services'

export class PurchaseOrder {
    id!: string
    vendor!: number | undefined
    phase!: string
    description!: string
    amount!: number | undefined
    poNumber!: string
    createdOn!: Date | undefined

    imageUrls!: string[]

    vendorName!: string
    phaseDescription!: string
    purchaserId!: number | undefined
    purchaserName!: string
    type!: number
    job!: string
    jobName!: string

    protected $setProperties(source: any, services: Services): void {
        let vendorName = ''
        if (source.vendor && services.data.vendors) {
            const match = services.data.vendors.items.filter(x => x.id === source.vendor)
            if (match.length > 0) {
                vendorName = match[0].name
            }
        }
        source.vendorName = vendorName

        // Phase description would need to come from Viewpoint data if available
        source.phaseDescription = source.phase || ''

        // Purchaser name would need to come from VpUser data if available
        source.purchaserName = ''

        // Job name from vpJobs
        let jobName = ''
        if (source.job && services.data.vpJobs) {
            const match = services.data.vpJobs.items.filter(x => x.id === source.job)
            if (match.length > 0) {
                jobName = match[0].name
            }
        }
        source.jobName = jobName
    }
}
